import React, { useContext, useEffect, useState } from 'react'
import Header from '../../Components/Header'
import { Link, useNavigate } from 'react-router-dom'
import MapContext from '../../Components/MapContext';
import toast from 'react-simple-toasts';
import axios from 'axios';
import BaseUrl from '../../BaseUrl';
import Swal from 'sweetalert2';
import "react-country-state-city/dist/react-country-state-city.css";

const AddBlog = () => {


    const navigate = useNavigate()






    const [name, setName] = useState(null)
    const [image, setImage] = useState(null)
    const [descr, setDescr] = useState(null)

    const submit = () => {
        if (!name) {
            toast('🚨 Must enter blog title!')
        }
        // else if (!image) {
        //     toast('🚨 Must add blog image!')
        // }
        // else if (!descr) {
        //     toast('🚨 Must enter blog description!')
        // }
        else {

            try {

                const param = new FormData()
                param.append('image', image)
                param.append('name', name)
                param.append('descr', descr)

// const param={
//     name: 'pend',
//         color: 'red',
//         user_id:2,
// }



                axios.post(`${BaseUrl.baseUrl}/blog/create`, param).then(res => {
                    if (res.data.status === 'ok') {
                        toast('🎉 Created Successfully!')
                        navigate(-1)
                    }
                    else if (res.data.status === 'fail') {
                        toast('🚩' + res.data.message)
                    }

                }).catch(err => {
                    toast('🚨' + err.message)
                })


            } catch (err) {
                toast('🚨 Something went wrong!')
            }

        }

    }



    return (
        <div id="content" className="app-content ms-0">
            <div className="d-flex align-items-center mb-3">
                <div>
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="#">Pages</Link>
                        </li>
                        <li className="breadcrumb-item active">Blog</li>
                    </ul>
                    <h1 className="page-header mb-0">Blog</h1>
                </div>
                <div className="ms-auto">
                    <Link to="/showBlogs" className="btn btn-theme fs-13px fw-semibold ">
                        Show Blog
                    </Link>
                </div>
            </div>
            <div className="row gx-4">
                <div className="col-xl-12">
                    <div className="card mb-4">
                        <div className="card-body">
                            <div className="response-message" />
                            <div >
                                <div className="mb-2 mt-3">
                                    <label htmlFor="">Title</label>
                                    <br />
                                    <input
                                        type="text"
                                        name="title"
                                        placeholder="Title"
                                        className="form-control"
                                        required=""
                                        onChange={(e) => { setName(e.target.value) }}
                                    />
                                </div>
                                <div className="mb-2 mt-3">
                                    <label htmlFor="">Image</label>
                                    <br />
                                    <input
                                        type="file"
                                        name="image"
                                        placeholder="Image"
                                        className="form-control"
                                        required=""
                                        onChange={(e) => { setImage(e.target.files[0]) }}
                                    />
                                </div>
                                <div className="mb-2 mt-3">
                                    <label htmlFor="">Description</label> <br />
                                    <textarea
                                        type="text"
                                        name="body"
                                        placeholder="Body"
                                        className="form-control"
                                        required=""
                                        onChange={(e) => { setDescr(e.target.value) }}
                                    />
                                </div>
                                <div className="mb-2 mt-2" style={{ float: "inline-end" }}>
                                    <button type="submit" className="btn btn-theme" onClick={submit}>
                                        Add Blog
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default AddBlog